import json from "@/data/copy/booking-form.json";
import { createCopyGetter } from "@/lib/localize-copy";

export const getBookingFormCopy = createCopyGetter(json);
